var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import React from 'react';
import { COLUMN, DATAGRID, ICON, SORT, TITLE } from '../../constants';
import classes from '../../utils/classes';
import cssJoin from '../../utils/cssJoin';
import when from '../../utils/when';
import withMemoRef from '../../utils/withMemoRef';
import Button from '../Button';
import Icon from '../Icon';
/**
 * DataGridColumnTitle component.
 *
 * @param props DataGridColumnTitle properties.
 */
export const DataGridColumnTitle = withMemoRef(
  'DataGridColumnTitle',
  (_a, ref) => {
    var {
        children,
        className,
        icon = 'arrow',
        iconClassName = cssJoin(SORT, ICON),
        sort,
        iconDirection = sort === 'asc' ? 'up' : 'down',
        iconFlip,
        iconHas,
        iconInverse,
        iconIs,
        iconRole,
        iconSize,
        iconSolid,
        iconTitle = typeof children === 'string' ? children : '',
        sortable = false
      } = _a,
      props = __rest(_a, [
        'children',
        'className',
        'icon',
        'iconClassName',
        'sort',
        'iconDirection',
        'iconFlip',
        'iconHas',
        'iconInverse',
        'iconIs',
        'iconRole',
        'iconSize',
        'iconSolid',
        'iconTitle',
        'sortable'
      ]);
    /**
     * Because this component can return a button or a span, the content is
     * defined here to avoid repetition.
     */
    const content = React.createElement(
      React.Fragment,
      null,
      children,
      when(sort, () =>
        React.createElement(Icon, {
          shape: icon,
          className: iconClassName,
          direction: iconDirection,
          flip: iconFlip,
          has: iconHas,
          inverse: iconInverse,
          is: iconIs,
          role: iconRole,
          size: iconSize,
          solid: iconSolid,
          title: iconTitle
        })
      )
    );
    return sortable
      ? React.createElement(
          Button,
          Object.assign(
            {
              'aria-sort':
                sort === 'asc'
                  ? 'ascending'
                  : sort === 'desc'
                  ? 'descending'
                  : 'none',
              className: classes([DATAGRID, COLUMN, TITLE], className),
              plain: true,
              role: 'columnheader'
            },
            Object.assign(Object.assign({}, props), { ref: ref })
          ),
          content
        )
      : React.createElement(
          'span',
          Object.assign(
            { className: classes([DATAGRID, COLUMN, TITLE], className) },
            Object.assign(Object.assign({}, props), { ref: ref })
          ),
          content
        );
  }
);
export default DataGridColumnTitle;
